<!--成品日完工报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="search-form-outbound" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['desOrganizationCode']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="desOrganizationCode"
          :value.sync="queryParams.desOrganizationCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-range-picker slot="assessmentDeliveryDate" v-model="currentDeliveryDateObj" @change="changeDeliveryRangeDate" />
        <a-range-picker slot="completeDate" v-model="completeDateObj" @change="changeCompleteRangeDate" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiCompletionReportListExport" ref="download" />
        <a-button v-hasPermi="['mes:mesDiscreteJobs:completionReportListExport']" type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'
import { apiCompletionReportList, apiCompletionReportListExport } from '@/api/report/finished-product-completion-report'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Finished-product-completion-report', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      currentDeliveryDateObj: [],
      completeDateObj: [],
      apiCompletionReportListExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiCompletionReportList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        wipEntityName: undefined,
        desOrganizationCode: undefined,
        staAssessmentDeliveryDate: undefined,
        endAssessmentDeliveryDate: undefined,
        staPackagingCompletionDate: undefined,
        endPackagingCompletionDate: undefined,
        wipEntityNameList: []
      },
      formList: [
        { label: '库存组织', decorator: ['desOrganizationCode'], type: 'desOrganizationCode' },
        { label: '工单号', decorator: ['wipEntityName'], type: 'input' },
        { label: '考核交期', type: 'assessmentDeliveryDate', decorator: ['assessmentDeliveryDate'] },
        { label: '实际完成日期', type: 'completeDate', decorator: ['completeDate'] }
      ],
      // 表格字段
      columns: [
        { title: '供应商', dataIndex: 'supplierName', align: 'center', width: 170, ellipsis: true },
        { title: '组织', dataIndex: 'desOrganizationName', align: 'center', width: 180 },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 180 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 170 },
        { title: '工单状态', dataIndex: 'statusName', align: 'center', width: 100 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 150 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 110 },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 180, ellipsis: true },
        { title: '需求数量', dataIndex: 'planQuantity', align: 'center', width: 100 },
        { title: '考核交期', dataIndex: 'assessmentDeliveryDate', align: 'center', width: 120, scopedSlots: { customRender: 'dateFormat' } },
        { title: '实际完成数量', dataIndex: 'realCompletedQty', align: 'center', width: 120 },
        { title: '实际完成日期', dataIndex: 'packagingCompletionDate', align: 'center', width: 120 },
        { title: '计划完成时间', dataIndex: 'scheduledCompletionDate', align: 'center', width: 150 }
      ]
    }
  },
  created() {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'desOrganizationCode',
        {
          currentDeliveryDateObj: ['staAssessmentDeliveryDate', 'endAssessmentDeliveryDate'],
          completeDateObj: ['staPackagingCompletionDate', 'endPackagingCompletionDate']
        },
        false
      )
    } else {
      this.queryParams.staAssessmentDeliveryDate = moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00')
      this.queryParams.endAssessmentDeliveryDate = moment().format('YYYY-MM-DD 23:59:59')
      this.currentDeliveryDateObj = [this.queryParams.staAssessmentDeliveryDate, this.queryParams.endAssessmentDeliveryDate]
    }
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 选择考核交期
    changeDeliveryRangeDate (dateArr, dateStrArr) {
      if (dateStrArr?.length > 0 && dateStrArr[0] && dateStrArr[1]) {
        this.queryParams.staAssessmentDeliveryDate = dateStrArr[0] + ' 00:00:00'
        this.queryParams.endAssessmentDeliveryDate = dateStrArr[1] + ' 23:59:59'
      } else {
        this.queryParams.staAssessmentDeliveryDate = undefined
        this.queryParams.endAssessmentDeliveryDate = undefined
      }
    },
    // 选择完成时间
    changeCompleteRangeDate (dateArr, dateStrArr) {
      if (dateStrArr?.length > 0 && dateStrArr[0] && dateStrArr[1]) {
        this.queryParams.staPackagingCompletionDate = dateStrArr[0] + ' 00:00:00'
        this.queryParams.endPackagingCompletionDate = dateStrArr[1] + ' 23:59:59'
      } else {
        this.queryParams.staPackagingCompletionDate = undefined
        this.queryParams.endPackagingCompletionDate = undefined
      }
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      if (this.queryParams?.desOrganizationCode) { params.desOrganizationCode = this.queryParams.desOrganizationCode }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      params.wipEntityNameList = params.wipEntityName ? [params.wipEntityName] : []
      if (params.wipEntityName) { delete params.wipEntityName }
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        wipEntityName: undefined,
        desOrganizationCode: undefined,
        staAssessmentDeliveryDate: undefined,
        endAssessmentDeliveryDate: undefined,
        staPackagingCompletionDate: undefined,
        endPackagingCompletionDate: undefined,
        wipEntityNameList: []
      }
      this.currentDeliveryDateObj = [];
      this.completeDateObj = [];
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
</style>
